import PokerRecorderDetailItem from "../../../../table/module/poker_recorder/poker_recorder_detail_item";
import { CardNameIndex, CardColor } from "../q2_card_common";

const { ccclass, property } = cc._decorator;

@ccclass
export default class Q2RecorderDetailItem extends PokerRecorderDetailItem{

    @property([cc.Node])
    nodeStarList: cc.Node[] = []



    setData(data){
        super.setData(data)
        let colorCountList = data.colorCountList || []
        for (let index = 0; index < this.nodeStarList.length; index++) {
            const node = this.nodeStarList[index];
            let colorCount = colorCountList[index] || 0
            node.active = colorCount > 0 && ((this.m_config.point == CardNameIndex.card_2 && index + 1 == CardColor.color_plum) || (this.m_config.point == CardNameIndex.card_Q && index + 1 == CardColor.color_black_heart))
        }
    }

}